<section class="service flex gap-5 align-items-center" [ngClass]="variantClass">
  <div class="text-block">
    <ng-content></ng-content>
  </div>
  <div>
    <ng-content select="[image]"></ng-content>
  </div>
</section>
